/* eslint-disable */
import getData from '../functions/getData';
import consentTypes from '../helpers/consentTypes';

export const dataSelector = 'header';

export const config = {
    /** Value configurable part **/
    // Only configure values according to usage / defaults
    availableConsentTypes: [
        consentTypes.CONSENT_TYPE_NECESSARY,
        // consentTypes.CONSENT_TYPE_PREFERENCES,
        consentTypes.CONSENT_TYPE_STATISTICS,
        consentTypes.CONSENT_TYPE_MARKETING
    ],
    querySelectorForToggleModal: 'a[href*="#cookie-consent-toggle"]',
    moreInfoLinkHref: '/datenschutz',
    externalCookieNames: {
        statistics: ['_pk_'], // ['_g', '_pk_'],
        marketing: [], // ['_fbp'],
    },

    /** Free configurable part **/
    // Use keys/values as you need them in your scripts to be appended in scripts.js
    scriptSettings: {
        statistics: {
            analytics: {

            },
            tracking: {
                matomo: {
                    key: getData('data-cookie-consent-matomo-side-id'), // getData('data-cookie-consent-gtm-tracking-key')
                },
                piwik: {
                    key: '',
                },
            },
        },
        marketing: {

        },
    },
};

